// The discovery controller is needed only on collection and search sections.
if (typeof document !== 'undefined' && document.querySelector('[data-discovery]')) {
  const controllerUrl = document.querySelector('script[data-discovery-controller-url]')?.dataset.discoveryControllerUrl || new URL('discovery-controller.js', import.meta.url).href;
  import(controllerUrl);
}
